import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCombobox,{staticClass:"mini",attrs:{"hide-details":"auto","value":_vm.value,"items":_vm.addresses,"dense":"","outlined":"","item-value":"id","item-text":_vm.addressLabel,"return-object":"","label":_vm.label ? _vm.label : ''},on:{"change":function($event){return _vm.$emit('change', $event)},"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }